export class LoginRequest {
    constructor(
        public email: string,
        public password: string,
        public timestamp: string,
        public ip_address: string,
        public key: string,
        public secret: string) {

    }
}

export class LoginSucceed {
    constructor(
        public user_id: string,
        public session_token: string,
        public access_token: string) {  }
}

export class RememberMe {
    constructor(
        public state: boolean,
        public username: string
    ) {}
}
